import { ref, watch } from 'vue';
import { CsvFormField } from '../csv-input/csv-form-field';

export class MassSelectFormField {
	public readonly specific: CsvFormField;
	public readonly allSelected = ref<boolean>(false);

	public constructor() {
		this.specific = new CsvFormField();

		watch(this.allSelected, () => this.onAllSelectedChanged());
	}

	private onAllSelectedChanged(): void {
		if (this.allSelected.value) {
			this.specific.clear();
		}
	}
}
